import {FAQModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./Accordion.module.scss"
import AccordionItem from "./AccordionItem"

interface AccordionProps {
	className?: string
	items: FAQModuleType[]
}

const Accordion = (props: AccordionProps) => {
	return (
		<div
			className={`${styles.accordionItems} ${props.className}`}
			// itemType={"https://schema.org/FAQPage"}
			// itemScope
		>
			{props.items.map((item: FAQModuleType, index: number) => {
				return <AccordionItem key={index} AccordionItem={item} />
			})}
		</div>
	)
}

export default Accordion
